export const selectTheme = {
  baseStyle: {
    field: {
      _disabled: {
        opacity: 1,
        cursor: 'not-allowed',
        background: 'gray.100'
      }
    }
  },
  defaultProps: {
    size: 'sm'
  }
}
